import React from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { StyledContainer } from "./styles";
import { ImProfile } from "react-icons/im";
import { AiOutlineLogout } from "react-icons/ai";

const UserMenu = () => {
  const { user, handleLogout } = useAuth();
  return (
    <StyledContainer>
      <h2>Bem vindo {user.fn ?? ""}!</h2>
      <div className="menu_container">
        <div
          onClick={() =>
            window.location.replace(
              String(process.env.REACT_APP_LOGIN_URL) + "/perfil"
            )
          }
        >
          <ImProfile />
          <p>Perfil</p>
        </div>
        <div onClick={handleLogout}>
          <AiOutlineLogout />
          <p>Sair</p>
        </div>
      </div>
    </StyledContainer>
  );
};

export default UserMenu;
